  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col >
          <h4 style="text-align:center;"> <span> Pesquise o Estudante e faça as operações</span></h4>

<div class="text-center">

 <v-container fluid>
    <v-row align="center">

      <v-col class="d-flex" cols="3" sm="3">
          <v-text-field
            v-model="pesquisa"
            label="Informe o número de matricula( ou Bilhete )"
          ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="4" sm="2" >

          <v-btn :disabled="pesquisa === ''" color="primary" @click="Pesquisar()"><v-icon>search</v-icon></v-btn>

      </v-col>
     <v-col class="d-flex" cols="4" sm="4" >

          <label style="color:red" v-if="!msg_pesquisa">Estudante não encontrado!</label>

          <v-menu :close-on-content-click="false"
            offset-x
            offset-y  >
            <template v-slot:activator="{ on }">
              <v-btn
                color="green darken-1"
                dark
                v-on="on"
                :disabled= !estudante_dados.length
              >
              <v-icon>settings</v-icon>
                Operações Admin
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="mudanca_classe()">Mudança de Classe</v-list-item>
              <v-list-item>Mudança de Turma</v-list-item>
              <v-list-item>Mudança de Curso</v-list-item>
          </v-list>
        </v-menu>


      </v-col>
       
    </v-row>
    <v-row>
        <v-col class="d-flex" cols="4" sm="5">
            <v-progress-linear v-if="progresso"
            color="green"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </v-col>

    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
        <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>
  <v-col md="6">
    <v-card-text>
      <strong> Dados Pessoais</strong>
    </v-card-text>
    <hr>
    <v-row>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Nome:{{(this.estudante_dados.length)?(this.estudante_dados[0].nome):''}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Matricula:{{(this.estudante_dados.length)?(this.estudante_dados[0].idMatricula):''}}</v-chip>
     </v-col>
    </v-row>
    <v-row>
     <v-col md="4">
          <v-chip style="margin:4px">Genero:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].sexo):''}}</strong></v-chip>
     </v-col>
     <v-col md="8">
          <v-chip style="margin:4px">Data de Nascimento:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].datanascimento):''}}</strong></v-chip>
     </v-col>
    </v-row>
     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Natural de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">BI:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].bi):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Filho de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">e De:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedamae):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="12">
          <v-chip style="margin:4px">Contacto:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].telefone):''}}</strong></v-chip>
     </v-col>

    </v-row>
    <v-row>

        <v-col>

            <v-col md="12">
        <v-chip
              color="pink" style="margin:4px;color:white"
            >
              Instituição Inscrito : {{(this.estudante_dados.length)?(this.estudante_dados[0].instituicao):''}}
            </v-chip>
    </v-col>

        </v-col>

    </v-row>

    <hr>
  </v-col>
  <v-col md="6">
    <v-card-text>
      <strong> {{titulo}}</strong>
    </v-card-text>
    <hr>

    <v-data-table
            :headers="headers"
            :items="this.estudante_dados"
          >
        <template v-slot:item.action="{ item }">
              <v-icon  color="primary" class="mr-2" v-if="item.idAno_Academico === 4" @click="editItem(item)">print</v-icon>
            </template>
      </v-data-table>

  </v-col>

</v-row>
  </v-card>

  <!-- ========================Modal de Mudança de Classe=======================-->


    <template>
        <v-row justify="center">
          <v-dialog v-model="dialogo_classe" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Mundança de Classe</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Nome do estudante" :disabled="true" v-model="editedItem.nome" ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Curso inscrito" :disabled="true" v-model="editedItem.descricao_curso"   ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        label="Classe Actual"
                         persistent-hint
                         :disabled="true"
                         v-model="editedItem.classe"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select
                        :items= "Classes_filtradas"
                        label="Selecione a Nova Classe"
                        v-model="classe_selecionada"
                        @change="loadTurma()"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select
                        :items="turmas_filtered"
                        item-text="idTurma"
                        label="Selecione a nova Turma"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <small >AnoLectivo( da ultima confirmação feita ):</small><strong>{{editedItem.anoLectivo}}</strong>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="dialogo_classe = false">Cancelar</v-btn>
                <v-btn color="green darken-1" text @click="dialog = false" >Confirmar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
</template>






  <!-- ========================FIM  do Modal=====================================-->
  </v-container>

</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({

    select1: null,
    pesquisa_parameto: null,
    estudante_dados: [],
    idMatricula: null,
    msg_pesquisa: true,
    dialogo_classe:false,
    classe_selecionada:'',
    pesquisa: '',
    estudante: true,
    progresso: false,
    Pessoas: [],
    turmasAll:[],
    turmas_filtered:[],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    Classes_filtradas:[],
    classes:["10ª Classe" , "11ª Classe" ,"12ª Classe" ],
    ruleRequired: [value => value || 'campo obrigatorio'],

    editedItem :
    {
        nome:'',
        pkPessoa:'',
        idMatricula:'',
        bi:'',
        datanascimento:'',
        nomedopai:'',
        nomedamae:'',
        telefone:'',
        descricao_turma:'',
        instituicao:'',
        descricao_curso:'',
        anoLectivo:'',
        resultado:'',
        classe:'',
        idAno_Academico:'',
        idCurso:''
    },

    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Curso - Inscrito ', value: 'descricao_curso' },
      { text: 'Classes( Feitas )', value: 'classe' },
      { text: 'Turma', value: 'descricao_turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aproveitamento', value: 'resultado' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeturmasAll()
  },
  methods: {

    async  Pesquisar () {
      try {
        this.progresso = true
        this.estudante_dados = await axios
          .get('/PesquisaGlobal/' + this.pesquisa)
          .then(res => res.data)
        this.progresso = false;
        
        if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
      } catch (error) {
        this.progresso = false
      }
    },

    loadTurma()
    {
        let valor = 0
        if( this.classe_selecionada === '10ª Classe')
            valor = 1
        else if(this.classe_selecionada === '11ª Classe')
            valor = 2
        else if( this.classe_selecionada === '12ª Classe' )
            valor = 3
        else if(this.classe_selecionada === '13ª Classe' )
            valor = 4

          this.turmas_filtered = this.turmasAll.filter( t=>t.idCurso === this.editedItem.idCurso && t.idAno_Academico === valor )
          
    },

     async initializeturmasAll () {
    //  turmaFindWithEstudanteCount

 
      try {
         this.turmasAll = await axios
          .get('/turmaFindAll/')
          .then(res => res.data)
          console.log(this.turmasAll);
          
        } catch (error) {
 
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    mudanca_classe()
    {

        this.dialogo_classe = true
        this.editedItem = Object.assign({}, this.estudante_dados[0])
        this.Classes_filtradas = this.classes.filter(p=>p !== this.editedItem.classe)
        
    }

  }

}

</script>
